import React from "react";
import PropTypes from "prop-types";

const ExportLoader = ({ type }) => {
    const today = new Date().toLocaleDateString();
    return (
    <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.4)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }}
    >
        <div style={{
            backgroundColor: '#FFFFFF',
            borderRadius: '4px',
            textAlign: 'center',
            padding: '20px'
        }}
        >
            <span>{type}_{today}</span>
        </div>
    </div>
    )
};

ExportLoader.propTypes = {
    type: PropTypes.string,
};

ExportLoader.defaultProps = {
    type: "",
};

export default ExportLoader;
